/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Scope_TitleInputs */

const en_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Scope`)
};

const de_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Geltungsbereich`)
};

const fr_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Champ d'application`)
};

const es_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Ámbito de aplicación`)
};

const it_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Ambito di applicazione`)
};

const nl_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Toepassingsgebied`)
};

const pl_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Zakres obowiązywania`)
};

const fi_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Soveltamisala`)
};

const da_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Anvendelsesområde`)
};

const sv_agb_scope_title = /** @type {(inputs: Agb_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Omfattning`)
};

/**
* | output |
* | --- |
* | "1. Scope" |
*
* @param {Agb_Scope_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_scope_title = /** @type {((inputs?: Agb_Scope_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Scope_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_scope_title(inputs)
	if (locale === "fr") return fr_agb_scope_title(inputs)
	if (locale === "es") return es_agb_scope_title(inputs)
	if (locale === "it") return it_agb_scope_title(inputs)
	if (locale === "nl") return nl_agb_scope_title(inputs)
	if (locale === "pl") return pl_agb_scope_title(inputs)
	if (locale === "fi") return fi_agb_scope_title(inputs)
	if (locale === "da") return da_agb_scope_title(inputs)
	if (locale === "sv") return sv_agb_scope_title(inputs)
	return en_agb_scope_title(inputs)
});